import type React from 'react';

import { ModifyContributions } from './components/ModifyContributions';
import { PaymentInfo } from './components/PaymentInfo';
import { StopContributions } from './components/StopContributions';

export const PageBody: React.FC = () => {
	return (
		<div className="flex flex-col gap-4">
			<ModifyContributions />

			<PaymentInfo />

			<StopContributions />
		</div>
	);
};
